import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import GstDashboard from '../GstDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import GstPageImpl from './GstPageImpl';

export default function GstPage() {
    const dispatch = useDispatch();
    const { gstList} = useSelector((state)=>state.pharmaslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < GstPageImpl />
    )

}